const SvgCheck = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.4707 8.98633C43.0811 8.99768 42.7113 9.16019 42.4394 9.43945L16.5 35.3789L5.56054 24.4395C5.42232 24.2955 5.25676 24.1806 5.07357 24.1014C4.89038 24.0222 4.69323 23.9804 4.49367 23.9784C4.29411 23.9763 4.09616 24.0141 3.91139 24.0896C3.72663 24.165 3.55877 24.2765 3.41766 24.4177C3.27654 24.5588 3.165 24.7266 3.08956 24.9114C3.01413 25.0962 2.97632 25.2941 2.97835 25.4937C2.98038 25.6932 3.0222 25.8904 3.10138 26.0736C3.18055 26.2568 3.29549 26.4223 3.43944 26.5605L15.4394 38.5605C15.7208 38.8417 16.1022 38.9997 16.5 38.9997C16.8977 38.9997 17.2792 38.8417 17.5605 38.5605L44.5605 11.5605C44.7769 11.3498 44.9247 11.0786 44.9844 10.7825C45.0441 10.4864 45.0131 10.1792 44.8953 9.901C44.7776 9.62283 44.5786 9.38669 44.3244 9.22349C44.0702 9.06029 43.7726 8.97763 43.4707 8.98633Z"
        fill="white"
      />
    </svg>
  );
};

export default SvgCheck;
